export default __webpack_public_path__ + "static/media/wrapper-logo.13d2cfe3.png";